import React, { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";

import GlobalStyle from "./styles/global";

import Router from "./Components/Router";

function App() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "/matomo/init.js";
    script.async = true;
    document.head.appendChild(script);
  }, []);

  return (
    <BrowserRouter>
      <GlobalStyle />
      <Router />
    </BrowserRouter>
  );
}

export default App;
